import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionsPerfil} from '../../actions/action-creators'
import {LoaderRedux} from '../../components/LoaderRedux'
import {State} from '../../reducers'
import Encabezado from './Components/Encabezado'
import MisDatos from './Components/PerfilUsuario/MisDatos'
import MiSuscripcion from './Components/PerfilUsuario/MiSuscripcion'
import { KEYS } from '../../constants/keysStorage'
import MisSucursales from './Components/PerfilUsuario/MisSucursales'

const PerfilUsuarioPage = () => {
  const loader = useSelector((state: State) => state.general.loader)
  const user = localStorage.getItem(KEYS.USERNAME_CLIENTE)
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionsPerfil, dispatch)
  const [loader2, setLoader2] = useState(true)

  useEffect(() => {
    getProfileData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getProfileData = async () => {
    await actions.perfilGetDataUser(user);
    setLoader2(false);
  }

  return (
    <>
      {!loader && loader2 && <LoaderRedux />}
      <Encabezado url='/home' />
      <div 
        id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6'
        className='w-layout-layout bill-section wf-layout-layout'
      >
        <MisDatos />
        <MiSuscripcion />
        <MisSucursales />
      </div>
    </>
  )
}

export default PerfilUsuarioPage
